import dialog from "@/presets/lara/dialog";

export const uploadOnBehalfTooltipPt = {
  arrow: "!hidden",
  text: "!w-[232px] !py-2.5 !px-3 !rounded-md !bg-indigo-base !text-xs !font-medium !leading-[1.45] !text-white shadow-[0_4px_12px_rgba(16,32,48,0.18)]",
};

export const uploadOnBehalfDialogPt = {
  ...dialog,
  root: (options: { state: Record<string, unknown> }) => ({
    class: [dialog.root(options).class, "flex flex-col overflow-hidden !rounded-xl"],
  }),
  header: {
    class: "flex items-start justify-between gap-4 px-6 pt-5 pb-4 bg-white border-b border-gray-175",
  },
  icons: {
    class: "flex items-center ml-auto",
  },
  closeButton: {
    class:
      "inline-flex items-center justify-center w-9 h-9 shrink-0 rounded-lg border border-gray-175 bg-white text-indigo-base hover:bg-error-100 hover:text-error-900 focus:outline-none focus-visible:ring-2 focus-visible:ring-teal-900",
  },
  content: () => ({
    class: "p-6 bg-white",
  }),
  footer: {
    class: "flex flex-wrap items-end justify-between gap-4 px-6 py-4 border-t border-gray-175 bg-blue-100",
  },
};
